module.exports = __webpack_public_path__ + "img/intro-figure-2.1031678b.svg";